import React, { useState } from "react";
import { useSelector } from "react-redux";
import { get, orderBy } from "lodash";
import PatientSearchingTable from "../../../../../components/PatientSearchingTable";
import { uploadClientFile } from "../../../../../services/uploadFileToCoreplus";
import { deleteReferralById } from "../../../../../services/rawReferrals";
import SpecialistFileUpload from "pages/shared/SpecialistFileUpload";

const UploadTestResultModal = ({ file, isModalOpen, onClose, onFinish, source }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  const specialistProfiles = useSelector((state) =>
    orderBy(get(state, "app.specialistProfiles", []), ["firstName", "lastName"], ["asc", "asc"])
  );

  const onSelectPatient = (patient) => setSelectedPatient(patient);

  const uploadTheTestResult = async () => {
    setFailureReason(null);
    setIsUploading(true);

    const { error: uploadError } = await uploadClientFile({
      clientId: selectedPatient?.patientId,
      //It is file name actually
      fileId: file?.name,
      source,
    });
    if (uploadError) {
      setFailureReason(uploadError.message);
      setIsUploading(false);
      return;
    }

    const { error: deleteError } = await deleteReferralById({ id: file?.id, source });
    if (deleteError) {
      setFailureReason(deleteError.message);
      setIsUploading(false);
      return;
    }

    onFinish && onFinish();
    setIsUploading(false);
  };

  return (
    <div className={`modal ${isModalOpen ? "is-active" : ""}`}>
      <div className="modal-background" onClick={onClose} />
      <div className="modal-content has-background-white" style={{ padding: "20px" }}>
        <p className="menu-label">SEARCH EXISTING CLIENTS</p>
        <PatientSearchingTable selectedPatient={selectedPatient} onSelectPatient={onSelectPatient} />
        <button
          disabled={!selectedPatient || isUploading}
          className={`button is-primary is-small is-radiusless${isUploading ? " is-loading" : ""}`}
          onClick={uploadTheTestResult}
        >
          Upload
        </button>
        <p className="has-text-danger is-size-7">{failureReason}</p>
        <div className="columns is-vcentered">
          <div className="column is-5">
            <hr />
          </div>
          <div className="column is-2 is-size-7 has-text-centered has-text-weight-bold">OR</div>
          <div className="column is-5">
            <hr />
          </div>
        </div>
        <SpecialistFileUpload
          file={file}
          specialistProfiles={specialistProfiles}
          fromReferralInbox={true}
          aiOcr={source === "ocr_clients"}
        />
      </div>
      <button className="modal-close is-large" aria-label="close" onClick={onClose} />
    </div>
  );
};

export default UploadTestResultModal;
